import React from "react";

import { useSelector, useDispatch } from "react-redux";

import {
  checkOfferAction,
  searchAlternativeTransports,
  setOfferId,
} from "amadeusredux/lib/hotelSlice";
import { MdAirplanemodeActive } from "react-icons/md";
import {
  airportcity,
  boardTypes,
  boardTypes as utilBoardTypes,
  propertyFromArray,
  roomAttributes,
  currencySymbol,
} from "../utils";
import AlternativeOfferFlights from "./AlternativeOfferFlights";

import { selectSystem } from "amadeusredux/lib/systemSlice";
import {
  comparableOffersForOffer,
  getOtherRailOffer,
  getOtherTransferOffer,
  roomTypesForTourOperator,
  sortOffersByFlight,
} from "../offerutils";

import OfferPriceChart from "./OfferPriceChart";

import { FormattedMessage } from "react-intl";
import TourOperatorsBoard from "./TourOperatorsBoard";
import TourOperatorRoom from "./TourOperatorRoom";
import HotelCrossViewOffer from "./HotelCrossViewOffer";
import { availabilityAndPriceCheck } from "amadeusredux/lib/api";
import LoadBar from "../components/LoadBar";
import Select from "react-select";
import { unwrapResult } from "@reduxjs/toolkit";
import { setRoomAttributesFilter } from "amadeusredux/lib/filterSlice";
const nf = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maxiimumFractionDigits: 2,
});

export default function HotelCrossViewOffers(props) {
  const [selectedOutboundAirport, setSelectedOutboundAirport] = React.useState({
    value: "",
    label: "Bitte Flughafen auswählen",
  });
  const [selectedDeparture, setSelectedDeparture] = React.useState({
    value: "",
    label: "Bitte Abflugzeit auswählen",
  });

  const [selectedArrival, setSelectedArrival] = React.useState({
    value: "",
    label: "Bitte Rückflugzeit auswählen",
  });

  const df = new Intl.DateTimeFormat("de-DE", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const df2 = new Intl.DateTimeFormat("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const sessionId = useSelector((state) => state.system.sessionId);

  const checkids = useSelector((state) => state.hotel.checkids);

  const [flexSelected, setFlexSelected] = React.useState(false);
  const selectedRoomAttributes = useSelector(
    (state) => state.filter.selectedRoomAttributes
  );

  const [roomTouroperators, setRoomTouroperators] = React.useState({
    value: "",
    tos: [],
  });

  const specialRoomType = useSelector((state) => state.search.specialRoomType);

  const [alternativeFlightPage, setAlternativeFlightPage] = React.useState(1);

  const roomdivRef = React.useRef(null);

  const dispatch = useDispatch();
  const scrollRef = React.useRef();
  const hotelOfferInfos = useSelector((state) => state.hotel.hotelOfferInfos);

  const stations = hotelOfferInfos.StationDictionary;
  const offerId = useSelector((state) => state.hotel.offerId);
  let hotels = hotelOfferInfos.HotelDictionary;
  const stateoffers = hotelOfferInfos.Offers?.Offer
    ? [...hotelOfferInfos.Offers?.Offer]
    : [];
  const { offsetTop } = scrollRef?.current ? scrollRef.current : 0;
  let offers = [...stateoffers];
  const hotelSpecialAmount = useSelector(
    (state) => state.hotel.hotelSpecialAmount
  );
  const selectedMarketingActions = useSelector(
    (state) => state.search.selectedMarketingActions
  );
  const hotelMarketingActions = useSelector(
    (state) => state.filter.hotelMarketingActions
  );

  const reservationoperatorsonly = useSelector(
    (state) => state.search.reservationoperatorsonly
  );

  const inboundtime = useSelector((state) => state.search.inboundtime);
  const outboundtime = useSelector((state) => state.search.outboundtime);
  const optionOperators = useSelector((state) => state.filter.optionOperators);

  offers.sort((a, b) =>
    a.PriceInfo.Price.value < b.PriceInfo.Price.value ? -1 : 1
  );

  if (
    reservationoperatorsonly &&
    Array.isArray(optionOperators) &&
    optionOperators.length > 0
  ) {
    offers = offers.filter((e) => {
      return (
        Array.isArray(optionOperators) &&
        optionOperators.find(
          (o) => o.touroperator === e.TourOperator?.TourOperatorCode
        )
      );
    });
  }

  const offersRoomAttributes = {};
  const filteredAttributes = {};

  for (let i = 0; i < offers.length; i++) {
    if (
      Array.isArray(
        offers[i].OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
      )
    ) {
      for (
        let j = 0;
        j <
        offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes
          .length;
        j++
      ) {
        if (
          roomAttributes[
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          ]
        ) {
          offersRoomAttributes[
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          ] = {
            label:
              roomAttributes[
                offers[i].OfferServices.Package.Accommodation.Room
                  .RoomAttributes[j]
              ],
          };
          if (
            selectedRoomAttributes.includes(
              offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[
                j
              ]
            )
          ) {
            filteredAttributes[
              offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[
                j
              ]
            ] = { selected: 1 };
          }
        } else {
          console.log(
            ">>>>>>>>>>>>>>>>>>>>>>>>>>>>> unknon roomattributre",
            offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j]
          );
        }
      }
    }
  }

  //console.log(hotelSpecialAmount);

  let allma = hotelMarketingActions.map((e) => e.label).join();

  let selma = [...selectedMarketingActions];
  //console.log([...selma], allma,hotelMarketingActions);

  selma = selectedMarketingActions.filter((e) => allma.indexOf(e) > -1);
  //console.log("SELMA--------------", [...selma], allma);
  if (selma.length > 0) {
    offers = offers.filter((e) => {
      let ct = 0;
      if (!Array.isArray(e.MarketingActions)) return false;
      if (Array.isArray(e.MarketingActions) && e.MarketingActions.length == 0)
        return false;
      for (let i = 0; i < e.MarketingActions.length; i++) {
        if (e.MarketingActions[i].MarketingProperties === null) continue;
        if (selma.includes(e.MarketingActions[i].MarketingProperties.label)) {
          //console.log(e.MarketingActions[i].MarketingProperties.text);
          ct++;
        }
      }
      return ct >= selma.length;
    });
  }

  if (Object.keys(filteredAttributes).length > 0) {
    let neededAttributes = Object.keys(filteredAttributes).length;
    offers = offers.filter((e) => {
      let propsfound = 0;
      if (
        !Array.isArray(
          e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
        )
      )
        return false;
      for (
        let i = 0;
        i <
        e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes.length;
        i++
      ) {
        if (
          filteredAttributes[
            e.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes[i]
          ]
        ) {
          propsfound = propsfound + 1;
        }
      }
      return propsfound === neededAttributes;
    });
  }

  const offersRoomAttributesAfterFilter = {};

  for (let i = 0; i < offers.length; i++) {
    if (
      Array.isArray(
        offers[i].OfferServices?.Package?.Accommodation?.Room?.RoomAttributes
      )
    ) {
      for (
        let j = 0;
        j <
        offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes
          .length;
        j++
      ) {
        let attribute =
          offers[i].OfferServices.Package.Accommodation.Room.RoomAttributes[j];
        if (roomAttributes[attribute]) {
          if (!offersRoomAttributesAfterFilter[attribute]) {
            offersRoomAttributesAfterFilter[attribute] = {
              count: 1,
            };
          } else {
            offersRoomAttributesAfterFilter[attribute].count =
              offersRoomAttributesAfterFilter[attribute].count + 1;
          }
        }
      }
    }
  }

  React.useEffect(() => {
    dispatch(
      setRoomAttributesFilter({
        offersRoomAttributesAfterFilter,
        offersRoomAttributes,
        filteredAttributes,
      })
    );
  }, [hotelOfferInfos, selectedRoomAttributes]);

  let rnames = hotelSpecialAmount.map((e) => e.value).join();

  let sprt = [...specialRoomType];

  sprt = sprt.filter((e) => rnames.indexOf(e) > -1);

  //console.log("###########",rnames);
  if (sprt.length > 0) {
    offers = offers.filter((e) => {
      let found = true;
      if (!Array.isArray(e.MarketingActions)) return false;
      if (e.MarketingActions.length < 1) return false;

      let roomnames = e.MarketingActions[0].RoomMouseover;

      if (!roomnames) return false;

      for (let j = 0; j < sprt.length; j++) {
        if (roomnames.indexOf(sprt[j]) === -1) {
          found = false;
        }
      }

      return found;
    });
  }

  //console.log(offers.length);

  const offer = offers.find((e) => e.OfferID === offerId)
    ? offers.find((e) => e.OfferID === offerId)
    : {};

  if (!offer.OfferID && offers.length > 0) {
    dispatch(setOfferId(offers[0].OfferID));
  }

  if (!offer.OfferID && offerId && offers.length > 0) {
    dispatch(setOfferId(offers[0].OfferID));
  }

  React.useEffect(() => {
    if (offer?.bookinginfo?.Status?.Status === "Available" && offerId) {
      if (
        !(
          Array.isArray(offer?.MarketingActions) &&
          offer.MarketingActions.length > 0 &&
          offer.MarketingActions[0].MarketingProperties.offeraction === true
        )
      )
        dispatch(checkOfferAction({ offerId: offerId, offer: offer }));
    }
  }, [offer, offer?.bookinginfo, offerId]);

  React.useEffect(() => {
    setShowAlternativeTransports(false);
    setAlternativeFlightPage(1);
  }, [offer.OfferID]);

  //console.log(offer);

  const alternativeTransports = useSelector((state) =>
    state.hotel.alternativeTransports[offer?.OfferID]
      ? state.hotel.alternativeTransports[offer.OfferID]
      : {}
  );
  //console.log(alternativeTransports);
  const [showAlternativeTransports, setShowAlternativeTransports] =
    React.useState(false);

  const hotel = hotels
    ? hotels.Hotel.find(
        (e) =>
          e.HotelID ===
          offer?.OfferServices?.Package?.Accommodation?.HotelRef?.HotelID
      )
    : {};
  const { loading } = useSelector(selectSystem);

  let tourOperator = "";
  if (offer) {
    tourOperator = offer.TourOperator?.TourOperatorCode;
  }

  const getAlternativeTransports = (off, offset) => {
    //console.log("######################");
    if (off?.OfferServices?.Package?.Flight)
      dispatch(
        searchAlternativeTransports({
          offer: off,
          offset: offset,
          cross: true,
          withActions: false,
        })
      )
        .then(unwrapResult)
        .then((originalPromiseResult) => {
          //console.log(originalPromiseResult);
          if (originalPromiseResult.Offers.MoreOffersAvailable) {
            getAlternativeTransports(
              off,
              offset + originalPromiseResult.Offers.OfferCount
            );
          }
        });
  };

  React.useEffect(() => {
    let tmp = document.getElementById("offerupgradeheadline");
    console.log(tmp);
    tmp?.scrollIntoView({ behavior: "smooth" });
  }, [showAlternativeTransports]);

  React.useEffect(() => {
    /*if (selectedArrival.value != "")
      setSelectedDeparture({ value: "", label: "Bitte Abflugzeit auswählen" });*/
    setAlternativeFlightPage(1);
  }, [selectedArrival]);

  React.useEffect(() => {
    /*if (selectedDeparture.value != "")
      setSelectedArrival({ value: "", label: "Bitte Rückflugzeit auswählen" });*/
    setAlternativeFlightPage(1);
  }, [selectedDeparture]);

  React.useEffect(() => {
    setSelectedDeparture({ value: "", label: "Bitte Abflugzeit auswählen" });
    setSelectedArrival({ value: "", label: "Bitte Rückflugzeit auswählen" });
    setAlternativeFlightPage(1);
  }, [selectedOutboundAirport]);

  React.useEffect(() => {
    getAlternativeTransports(offer, 0);
    setSelectedOutboundAirport({
      value: "",
      label: "Bitte Flughafen auswählen",
    });
    setSelectedDeparture({ value: "", label: "Bitte Abflugzeit auswählen" });
    setSelectedArrival({ value: "", label: "Bitte Rückflugzeit auswählen" });
    setAlternativeFlightPage(1);
  }, [offer.OfferID, inboundtime, outboundtime]);

  const roomTypes = roomTypesForTourOperator(tourOperator, offers);

  //const boardTypes = boardTypesForTourOperator(tourOperator, offers);

  const comparableOffers = comparableOffersForOffer(offer, offers);
  //console.log(offer);
  if (offer.OfferServices?.Package?.Flight)
    sortOffersByFlight(comparableOffers);

  const allBoards = [];
  if (Array.isArray(offers)) {
    for (let i = 0; i < offers.length; i++) {
      let offer = offers[i];
      if (
        allBoards.find(
          (e) => e.value === offer.OfferServices.Package.Accommodation.BoardType
        )
      ) {
        continue;
      }
      allBoards.push({
        label: propertyFromArray(
          boardTypes,
          offer.OfferServices.Package.Accommodation.BoardType,
          "value",
          "label"
        ),
        value: offer.OfferServices.Package.Accommodation.BoardType,
        order: utilBoardTypes.find(
          (e) => offer.OfferServices.Package.Accommodation.BoardType === e.value
        ).order,
      });
    }
  }

  allBoards.sort((a, b) => a.order - b.order);

  const allRoomNames = [];
  if (Array.isArray(offers)) {
    for (let i = 0; i < offers.length; i++) {
      let offer = offers[i];
      let rn = offer.OfferServices?.Package?.Accommodation?.Room?.SLBRoomName;
      if (!rn) rn = offer.OfferServices?.Package?.Accommodation?.Room?.RoomName;
      if (!rn) continue;

      let ar = allRoomNames.find((e) => e.value === rn);
      if (ar) {
        if (!ar.tos.includes(offer.TourOperator.TourOperatorCode)) {
          ar.tos.push(offer.TourOperator.TourOperatorCode);
        }
      } else {
        allRoomNames.push({
          label: rn,
          value: rn,
          tos: [offer.TourOperator.TourOperatorCode],
          offer: offer,
        });
      }
    }
  }

  allRoomNames.sort((a, b) => a.label.localeCompare(b.label));

  const tourOperators = [];
  if (Array.isArray(offers)) {
    for (let i = 0; i < offers.length; i++) {
      let offer = offers[i];

      let to = tourOperators.find(
        (e) => e.label === offer.TourOperator.TourOperatorName
      );

      if (to) {
        let offerrealprice = 0;
        let cacheprice = offer.PriceInfo.Price.value * 1;
        let checked = 0;
        if (offer?.bookinginfo) {
          checked = -1;
        }
        if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
          checked = 1;
          offerrealprice =
            (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1) /
            (offer.adults * 1 + offer.children * 1);
        } else {
          offerrealprice = offer.PriceInfo.Price.value * 1;
        }

        to.offers.push({
          offerid: offer.OfferID,
          price: offerrealprice,
          cacheprice: cacheprice,
          checked: checked,
          boardtype: offer.OfferServices.Package.Accommodation.BoardType,
          value: offer.TourOperator.TourOperatorCode,
        });
      } else {
        let offerrealprice = 0;
        let cacheprice = offer.PriceInfo.Price.value * 1;
        let checked = 0;
        if (offer?.bookinginfo) {
          checked = -1;
        }
        if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
          checked = 1;
          offerrealprice =
            (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1) /
            (offer.adults * 1 + offer.children * 1);
        } else {
          offerrealprice = offer.PriceInfo.Price.value * 1;
        }

        let mp = {};
        if (
          Array.isArray(offer.MarketingActions) &&
          offer.MarketingActions.length > 0
        ) {
          mp = offer.MarketingActions.find(
            (e) => e.MarketingProperties?.typ === "0022-0002"
          );
          if (mp) mp = mp.MarketingProperties;
        }
        if (!mp) mp = {};

        tourOperators.push({
          offers: [
            {
              offerid: offer.OfferID,
              price: offerrealprice,
              cacheprice: cacheprice,
              checked: checked,
              value: offer.TourOperator.TourOperatorCode,
              boardtype: offer.OfferServices.Package.Accommodation.BoardType,
            },
          ],
          image: offer.TourOperator.TourOperatorImage,
          label: offer.TourOperator.TourOperatorName,
          code: offer.TourOperator.TourOperatorCode,

          flexoption:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? offer.MarketingActions[0].flexoption
              : "",

          flexoptiontext:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? offer.MarketingActions[0].flexoptiontext
              : "",

          reservation:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? offer.MarketingActions[0].reservation
              : "",
          reservationtext:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? offer.MarketingActions[0].reservationtext
              : "",
          touroperatoraction:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? offer.MarketingActions[0].touroperatoraction
              : "",
          marketingproperties:
            Array.isArray(offer.MarketingActions) &&
            offer.MarketingActions.length > 0
              ? mp
              : {},
        });
      }
    }
  }

  let transferincl = false;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferincl = true;
    }
  }
  let railandfly = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandfly = true;
    }
  }
  let cancellationoption = "";
  if (offer?.OfferProperties?.CancellationOption) {
    cancellationoption = offer?.OfferProperties?.CancellationOption;
  }

  let otherTransferOffer = getOtherTransferOffer(
    offers,
    offer,
    transferincl,
    railandfly,
    cancellationoption
  );

  let otherRailOffer = getOtherRailOffer(
    offers,
    offer,
    transferincl,
    railandfly,
    cancellationoption
  );

  let otherRoomOffers = [];

  for (let i = 0; i < offers.length; i++) {
    if (offer.OfferID === offers[i].OfferID) continue;
    let trans =
      offers[i].OfferProperties?.TransferInfos?.includes("TransferIncluded");
    let rf = offers[i].OfferProperties?.OfferIncludes?.includes("RailAndFly");
    rf = rf ? true : false;
    let co = offers[i]?.OfferProperties?.CancellationOption;
    co = co ? co : "";
    if (
      offers[i].TourOperator?.TourOperatorCode ===
        offer.TourOperator?.TourOperatorCode &&
      offers[i].OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
        .DepartureAirportRef.AirportCode ===
        offer.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
          .DepartureAirportRef.AirportCode &&
      offers[i].OfferServices.Package.Accommodation.Room.RoomName !==
        offer.OfferServices.Package.Accommodation.Room.RoomName &&
      offers[i].OfferServices.Package.Accommodation.BoardType ===
        offer.OfferServices.Package.Accommodation.BoardType &&
      rf === railandfly &&
      trans === transferincl &&
      cancellationoption === co
    ) {
      if (
        !otherRoomOffers.find(
          (e) =>
            e.label ===
            offers[i].OfferServices.Package.Accommodation.Room.RoomName
        )
      )
        otherRoomOffers.push({
          label: offers[i].OfferServices.Package.Accommodation.Room.RoomName,
          offer: offers[i],
        });
    }
  }

  let otherViewOffers = [];

  for (let i = 0; i < offers.length; i++) {
    if (offer.OfferID === offers[i].OfferID) continue;
    let trans =
      offers[i].OfferProperties?.TransferInfos?.includes("TransferIncluded");
    let rf = offers[i].OfferProperties?.OfferIncludes?.includes("RailAndFly");
    rf = rf ? true : false;
    let co = offers[i]?.OfferProperties?.CancellationOption;
    co = co ? co : "";
    if (
      offers[i].TourOperator?.TourOperatorCode ===
        offer.TourOperator?.TourOperatorCode &&
      offers[i].OfferServices.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureAirportRef.AirportCode ===
        offer.OfferServices.Package?.Flight?.OutboundFlight.FlightDeparture
          .DepartureAirportRef.AirportCode &&
      offers[i].OfferServices.Package.Accommodation.Room.RoomName ===
        offer.OfferServices.Package.Accommodation.Room.RoomName &&
      offers[i].OfferServices.Package.Accommodation.Room.RoomView !==
        offer.OfferServices.Package.Accommodation.Room.RoomView &&
      offers[i].OfferServices.Package.Accommodation.BoardType ===
        offer.OfferServices.Package.Accommodation.BoardType &&
      rf === railandfly &&
      trans === transferincl &&
      cancellationoption === co
    ) {
      if (
        !otherViewOffers.find(
          (e) =>
            e.label ===
            offers[i].OfferServices.Package.Accommodation.Room.RoomView
        )
      )
        otherViewOffers.push({
          label: offers[i].OfferServices.Package.Accommodation.Room.RoomView,
          offer: offers[i],
        });
    }
  }

  let otherBoardOffers = [];

  for (let i = 0; i < offers.length; i++) {
    if (offer.OfferID === offers[i].OfferID) continue;
    let trans =
      offers[i].OfferProperties?.TransferInfos?.includes("TransferIncluded");
    let rf = offers[i].OfferProperties?.OfferIncludes?.includes("RailAndFly");
    rf = rf ? true : false;
    let co = offers[i]?.OfferProperties?.CancellationOption;
    co = co ? co : "";
    if (
      offers[i].TourOperator?.TourOperatorCode ===
        offer.TourOperator?.TourOperatorCode &&
      offers[i].OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
        .DepartureAirportRef.AirportCode ===
        offer.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
          .DepartureAirportRef.AirportCode &&
      offers[i].OfferServices.Package.Accommodation.Room.RoomName ===
        offer.OfferServices.Package.Accommodation.Room.RoomName &&
      offers[i].OfferServices.Package.Accommodation.BoardType !==
        offer.OfferServices.Package.Accommodation.BoardType &&
      rf === railandfly &&
      trans === transferincl &&
      cancellationoption === co
    ) {
      if (
        !otherBoardOffers.find(
          (e) =>
            e.label ===
            propertyFromArray(
              boardTypes,
              offers[i].OfferServices.Package.Accommodation.BoardType,
              "value",
              "label"
            )
        )
      )
        otherBoardOffers.push({
          label: propertyFromArray(
            boardTypes,
            offers[i].OfferServices.Package.Accommodation.BoardType,
            "value",
            "label"
          ),
          offer: offers[i],
        });
    }
  }

  let otherCancelOffers = [];

  for (let i = 0; i < offers.length; i++) {
    if (offer.OfferID === offers[i].OfferID) continue;
    let trans =
      offers[i].OfferProperties?.TransferInfos?.includes("TransferIncluded");
    let rf = offers[i].OfferProperties?.OfferIncludes?.includes("RailAndFly");
    rf = rf ? true : false;
    let co = offers[i]?.OfferProperties?.CancellationOption;
    co = co ? co : "";

    if (
      offers[i].TourOperator?.TourOperatorCode ===
        offer.TourOperator?.TourOperatorCode &&
      offers[i].OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
        .DepartureAirportRef.AirportCode ===
        offer.OfferServices.Package.Flight?.OutboundFlight.FlightDeparture
          .DepartureAirportRef.AirportCode &&
      offers[i].OfferServices.Package.Accommodation.Room.RoomName ===
        offer.OfferServices.Package.Accommodation.Room.RoomName &&
      offers[i].OfferServices.Package.Accommodation.BoardType !==
        offer.OfferServices.Package.Accommodation.BoardType &&
      rf === railandfly &&
      trans === transferincl &&
      cancellationoption !== co
    ) {
      if (!otherCancelOffers.find((e) => e.label === co))
        otherCancelOffers.push({
          label: co,
          offer: offers[i],
        });
    }
  }

  //console.log(
  //  offer?.OfferServices?.Package?.Flight?.OutboundFlight?.FlightDeparture
  //);

  let outboundStations = [];
  let inboundStations = [];

  const airports = stations?.Station;

  if (Array.isArray(alternativeTransports?.Offers?.Offer)) {
    for (let i = 0; i < alternativeTransports.Offers.Offer.length; i++) {
      if (
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.OutboundFlight?.FlightDeparture?.DepartureAirportRef?.AirportCode &&
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.OutboundFlight?.FlightDeparture?.DepartureDate &&
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.OutboundFlight?.FlightDeparture?.DepartureTime
      ) {
        let outboundairport =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .OutboundFlight.FlightDeparture.DepartureAirportRef.AirportCode;
        let date =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .OutboundFlight.FlightDeparture.DepartureDate;
        let time =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .OutboundFlight.FlightDeparture.DepartureTime;
        let row = outboundStations.find((e) => e.value === outboundairport);
        let outboundFlight =
          alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
            ?.OutboundFlight;

        let outboundairline = "";
        if (outboundFlight?.Airline?.AirlineName) {
          outboundairline = outboundFlight.Airline.AirlineName;
        }
        if (!row) {
          outboundStations.push({
            value: outboundairport,
            label:
              Array.isArray(airports) &&
              airports.find((e) => e.StationCode === outboundairport) !==
                undefined
                ? airports.find((e) => e.StationCode === outboundairport).Name
                : outboundairport,
            times: [
              {
                value: outboundairport + time + date,
                label:
                  df2.format(new Date(date)) +
                  " " +
                  time +
                  (outboundairline ? " " + outboundairline : ""),
                outboundairport: outboundairport,
                time: time,
                date: date,
              },
            ],
          });
        } else {
          let rt = row.times.find((e) => e.time === time && e.date === date);
          if (!rt) {
            row.times.push({
              value: outboundairport + time + date,
              label:
                df2.format(new Date(date)) +
                " " +
                time +
                (outboundairline ? " " + outboundairline : ""),
              outboundairport: outboundairport,
              time: time,
              date: date,
            });
          }
        }
      }

      if (
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.OutboundFlight?.FlightDeparture?.DepartureAirportRef?.AirportCode &&
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.InboundFlight?.FlightDeparture?.DepartureDate &&
        alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
          ?.InboundFlight?.FlightDeparture?.DepartureTime
      ) {
        let inboundairport =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .OutboundFlight.FlightDeparture.DepartureAirportRef.AirportCode;
        let date =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .InboundFlight.FlightDeparture.DepartureDate;
        let time =
          alternativeTransports?.Offers?.Offer[i].OfferServices.Package.Flight
            .InboundFlight.FlightDeparture.DepartureTime;
        let row = inboundStations.find((e) => e.value === inboundairport);
        let inboundFlight =
          alternativeTransports?.Offers?.Offer[i].OfferServices?.Package?.Flight
            ?.InboundFlight;
        let inboundairline = "";

        if (inboundFlight?.Airline?.AirlineName) {
          inboundairline = inboundFlight.Airline.AirlineName;
        }
        if (!row) {
          inboundStations.push({
            value: inboundairport,
            label:
              Array.isArray(airports) &&
              airports.find((e) => e.StationCode === inboundairport) !==
                undefined
                ? airports.find((e) => e.StationCode === inboundairport).Name
                : inboundairport,
            times: [
              {
                value: inboundairport + time + date,
                label:
                  df2.format(new Date(date)) +
                  " " +
                  time +
                  (inboundairline ? " " + inboundairline : ""),
                inboundairport: inboundairport,
                time: time,
                date: date,
              },
            ],
          });
        } else {
          let rt = row.times.find((e) => e.time === time && e.date === date);
          if (!rt) {
            row.times.push({
              value: inboundairport + time + date,
              label:
                df2.format(new Date(date)) +
                " " +
                time +
                (inboundairline ? " " + inboundairline : ""),
              inboundairport: inboundairport,
              time: time,
              date: date,
            });
          }
        }
      }
    }
  }

  for (let i = 0; i < outboundStations.length; i++) {
    outboundStations[i].times = outboundStations[i].times
      .sort((a, b) => a.date.localeCompare(b.date))
      .sort((a, b) => a.time.localeCompare(b.time));
  }

  for (let i = 0; i < inboundStations.length; i++) {
    inboundStations[i].times = inboundStations[i].times
      .sort((a, b) => a.date.localeCompare(b.date))
      .sort((a, b) => a.time.localeCompare(b.time));
  }

  let roomnamesoverview = false;

  if (
    Array.isArray(offers) &&
    offers.length > 0 &&
    Array.isArray(offers[0].MarketingActions) &&
    offers[0].MarketingActions.length > 0 &&
    offers[0].MarketingActions[0].roomnamesoverview
  ) {
    roomnamesoverview = offers[0].MarketingActions[0].roomnamesoverview;
  }

  for (let i = 0; i < tourOperators.length; i++) {
    for (let j = 0; j < allBoards.length; j++) {
      let bt = allBoards[j];
      let cheapest = tourOperators[i].offers.find(
        (e) => e.boardtype === bt.value
      );

      if (cheapest) {
        let off = offers.find((e) => e.OfferID === cheapest.offerid);
        if (
          off &&
          !off?.bookinginfo &&
          Array.isArray(checkids) &&
          !checkids.includes(off.OfferID)
        )
          availabilityAndPriceCheck(
            dispatch,
            sessionId,
            off.OfferID,
            off.adults,
            off.children,
            undefined
          );
      }
    }
  }
  //console.log("alternativeTransports", alternativeTransports);
  return (
    <div
      style={{
        paddingLeft: 16,
        /*paddingRight: 32,*/
        paddingBottom: 32,
        width: "100%",
      }}
    >
      {/*JSON.stringify(offer)*/}
      <LoadBar
        offers={offers}
        view={"hotel"}

        
        text={
          Array.isArray(offers) &&
          offers.length > 0 &&
          Array.isArray(offers[0].MarketingActions) &&
          offers[0].MarketingActions.length > 0 &&
          offers[0].MarketingActions[0].checkinfo
            ? offers[0].MarketingActions[0].checkinfo
            : "prüfe Veranstalterangebote" }
      />
      <br />
      <div className="crossframe">
        <div
          style={{
            boxSizing: "border-box",
            padding: 16,

            backgroundColor: "rgba(255,255,255,0.1)",
          }}
        >
          <OfferPriceChart offer={offer} />
        </div>
        <br />

        {roomnamesoverview && (
          <div
            ref={roomdivRef}
            className="crosspart"
            style={{
              boxSizing: "border-box",
              borderRadius: 8,
              margin: 16,
              height: (allRoomNames.length / 2) * 24,
              position: "relative",
              boxShadow: " 0px 3px 15px 0px rgba(0, 0, 0, 0.1)",
              backgroundColor: "rgba(255,255,255,0.1)",
            }}
          >
            {allRoomNames.map((e, i) => {
              let k = 0.9; //Math.floor(Math.random() * 200);
              //if (k > 100) k = 100;
              //k = 255 - k;

              k =
                allRoomNames[0].offer.PriceInfo.Price.value /
                e.offer.PriceInfo.Price.value;
              //k = 1 - k;
              k = k / 1.9;
              if (k > 0.9) k = 0.9;
              k = 255 - k * 255;

              let divWidth = roomdivRef.current
                ? roomdivRef.current.offsetWidth
                : 0;

              let fs = e.offer.PriceInfo.Price.value % 15;
              if (fs < 10) fs = 10;

              let txtLength = e.label.length * fs;

              let left =
                (e.offer.PriceInfo.Price.value % 100) -
                (allRoomNames[0].offer.PriceInfo.Price.value % 100);
              left = Math.abs(left);
              if (left > 100) left = 90;
              left = left / 100;
              //left = left + 0.1 * i;
              //console.log(left);
              //left = left * (i % 2 ? txtLength : divWidth / 2) + ((i % 2 ? 16 : txtLength));
              left = (i % 2 ? divWidth / 2 : 16) + (divWidth / 2) * left;
              //console.log(left);
              if (left > divWidth - txtLength) {
                left = divWidth - txtLength;
              }
              if (left > divWidth / 2 - txtLength && !(i % 2)) {
                left = divWidth / 2 - txtLength;
              }
              if (left < 16) {
                left = divWidth - txtLength;
              }
              //console.log(left);
              let top = (i % 2 ? i - 1 : i) * 8;
              if (top > (allRoomNames.length / 2) * 24 - 20) {
                top = (allRoomNames.length / 2) * 24 - 20;
              }

              top =
                top +
                (((i % 3 === 0 ? -1 : 1) * e.offer.PriceInfo.Price.value) % 4);
              if (top < 4) top = 4;
              //console.log(top);

              return (
                <div
                  style={{
                    position: "absolute",
                    fontSize: fs + "pt",
                    top: top,
                    left: left,
                    color: "rgb(" + k + "," + k + "," + k + ")",
                  }}
                >
                  {i > 0 && <span></span>}
                  <span
                    style={{
                      cursor: "pointer",
                      color:
                        e.value === roomTouroperators.value
                          ? "#000000"
                          : undefined,
                      fontWeight:
                        e.value === roomTouroperators.value ? 700 : 400,
                    }}
                    onClick={() => {
                      //window.scrollTo(0, offsetTop);
                      dispatch(setOfferId(e.offer.OfferID));
                      props.setOperator(e.offer.TourOperator.TourOperatorCode);
                      setRoomTouroperators(e);
                    }}
                  >
                    {e.label}
                  </span>
                </div>
              );
            })}
          </div>
        )}
        <br />
        <div
          className="crosspart"
          style={{
            boxSizing: "border-box",
            margin: 16,
            paddingTop: 16,
            backgroundColor: "rgba(255,255,255,0.1)",
          }}
        >
          <TourOperatorsBoard
            setOfferId={(id) => dispatch(setOfferId(id))}
            allBoards={allBoards}
            tourOperators={tourOperators}
            travellerfactor={offer.adults * 1 + offer.children * 1}
            currencyCode={offer.PriceInfo?.Price?.CurrencyCode}
            offsetTop={offsetTop}
            setOperator={(val) => props.setOperator(val)}
            roomTouroperators={roomTouroperators}
            setFlexSelected={setFlexSelected}
          />
        </div>
      </div>
      <br />
      <div className="crossframe2" id="crossframe2">
        <div className="crossframe2headline">
          Alle verfügbaren Leistungskombinationen des Veranstalters{" "}
          {offer?.TourOperator?.TourOperatorName}
        </div>
        <div className="crossframe2headline">
          (Preise für Standardangebote)
        </div>
        {offers.length === 0 && loading < 1 && (
          <span>
            <br />
            Es wurden keine Angebote zu Ihrer Auswahl gefunden.
            <br />
          </span>
        )}
        <div
          ref={scrollRef}
          className="crosspart2"
          style={{
            boxSizing: "border-box",
            paddingTop: 16,
            backgroundColor: "rgba(255,255,255,0.1)",
          }}
        >
          <TourOperatorRoom
            setOfferId={(id) => dispatch(setOfferId(id))}
            allBoards={allBoards}
            roomTypes={roomTypes}
            travellerfactor={offer.adults * 1 + offer.children * 1}
            offer={offer}
            offsetTop={offsetTop}
            setFlexSelected={setFlexSelected}
          />
        </div>

        {offer.OfferID && (
          <>
            <HotelCrossViewOffer
              id={"hotelcrossviewoffer"}
              offer={offer}
              flexSelected={flexSelected}
              setFlexSelected={setFlexSelected}
              otherRoomOffers={otherRoomOffers}
              otherCancelOffers={otherCancelOffers}
              otherBoardOffers={otherBoardOffers}
              otherTransferOffer={otherTransferOffer}
              otherRailOffer={otherRailOffer}
              otherViewOffers={otherViewOffers}
              stations={stations}
              hotel={hotel}
              hotelOfferInfos={hotelOfferInfos}
              transferincl={transferincl}
              cancellationoption={cancellationoption}
              railandfly={railandfly}
              offsetTop={offsetTop}
              alternativeTransportsButton={
                <span>
                  {Array.isArray(alternativeTransports?.Offers?.Offer) &&
                    alternativeTransports.Offers.Offer.length > 1 && (
                      <span
                        className="hotelofferframe3"
                        onClick={() => {
                          if (!showAlternativeTransports) {
                            setShowAlternativeTransports(true);
                          } else {
                            setShowAlternativeTransports(false);
                          }
                        }}
                      >
                        {!showAlternativeTransports ? (
                          <span className="hotelofferframe4">
                            Alternative Flüge &#x25B4;
                          </span>
                        ) : (
                          <span className="hotelofferframe5">
                            Alternative Flüge &#x25BE;
                          </span>
                        )}
                      </span>
                    )}
                </span>
              }
            />
            <div id="crosstest"></div>
            {Array.isArray(alternativeTransports?.Offers?.Offer) &&
              alternativeTransports.Offers.Offer.length > 1 &&
              showAlternativeTransports && (
                <>
                  <div
                    className="offerupgradeheadline"
                    id="offerupgradeheadline"
                  >
                    Alternativflüge
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      boxSizing: "border-box",
                      borderRadius: 8,
                      padding: 16,
                      marginTop: 16,
                      boxShadow: " 0px 3px 15px 0px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "rgba(255,255,255,0.1)",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ flexGrow: 1 }}>
                        <Select
                          options={[
                            {
                              value: "",
                              label: "Bitte Flughafen auswählen",
                            },
                            ...outboundStations,
                          ]}
                          value={selectedOutboundAirport}
                          onChange={(val) => {
                            setSelectedOutboundAirport(val);
                          }}
                        />
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <Select
                          options={
                            Array.isArray(outboundStations) &&
                            selectedOutboundAirport.value
                              ? [
                                  {
                                    value: "",
                                    label: "Bitte Abflugzeit auswählen",
                                  },
                                  ...outboundStations.find(
                                    (e) =>
                                      e.value === selectedOutboundAirport.value
                                  ).times,
                                ]
                              : []
                          }
                          isDisabled={!selectedOutboundAirport?.value}
                          value={selectedDeparture}
                          onChange={(val) => {
                            setSelectedDeparture(val);
                          }}
                        />
                      </div>
                      <div style={{ flexGrow: 1 }}>
                        <Select
                          options={
                            Array.isArray(inboundStations) &&
                            selectedOutboundAirport.value
                              ? [
                                  {
                                    value: "",
                                    label: "Bitte Rückflugzeit auswählen",
                                  },
                                  ...inboundStations.find(
                                    (e) =>
                                      e.value === selectedOutboundAirport.value
                                  ).times,
                                ]
                              : []
                          }
                          value={selectedArrival}
                          isDisabled={!selectedOutboundAirport?.value}
                          onChange={(val) => {
                            setSelectedArrival(val);
                          }}
                        />
                      </div>
                    </div>

                    <div>
                      <AlternativeOfferFlights
                        flexSelected={flexSelected}
                        selectedDeparture={selectedDeparture}
                        selectedArrival={selectedArrival}
                        selectedOutboundAirport={selectedOutboundAirport}
                        mainOffer={false}
                        flightOffer={true}
                        comparableOffers={alternativeTransports?.Offers?.Offer}
                        alternativeFlightPage={alternativeFlightPage}
                        setAlternativeFlightPage={setAlternativeFlightPage}
                        offer={offer}
                        display={false}
                        stations={stations}
                        offsetTop={offsetTop}
                        addOffer={true}
                        hotelOfferInfos={hotelOfferInfos}
                      />
                    </div>
                  </div>
                </>
              )}
          </>
        )}
      </div>
    </div>
  );
}


